import { ROLE_MODULE } from 'utils/constants';

const KEYS = {
  PROFILE: 'profiles',
  SESSION: 'sessions',
  ACCOUNT: 'account',
  ACCOUNT_USER: 'account-user',
  STATUS: 'status',
  ACTIVE_EMAILS: 'activeEmails',
  ACCOUNT_SETTINGS: 'account-settings',
  COUNTRIES: 'countries',
  STATES: 'states',
  CITIES: 'cities',
  TIMEZONES: 'timezones',
  SUBSCRIPTION: 'subscription',
  PLAN: 'plan',
  PLAN_SUMMARY: 'plan-summary',
  PLAN_SMS: 'plan-sms',
  PUBLIC_PLAN_SUMMARY: 'public-plan-summary',
  ACCOUNT_ROLES: 'account-roles',
  ACCOUNT_USERS: 'account-users',
  ROLE_PERMISSIONS: 'role-permissions',
  FEATURE_FLAGS: 'feature-flags',
  BILLING_PROFILE: 'billing-profile',
  BILLING_SUBSCRIPTION: 'billing-subscription',
  BILLING_INVOICES: 'billing-invoices',
  PLAN_CALCULATE: 'plan-calculate',
  WEBHOOKS: 'webhooks',
  AUTOMATIONS: 'automations',
  TRIGGERS: 'triggers',
  TOKENS: 'tokens',
  STRIPE_PRODUCT: 'stripe-product',
  VIEWS: 'views',
  VIEW_DATAS: 'view_datas',
  FIELDS: 'fields',
  SMS: 'sms',
  ACTIVE_AGENTS: 'active-agents',
  VOICES: 'VOICES',
};

const ROLE_MODULES = [
  { label: 'ACCOUNT', value: ROLE_MODULE.ACCOUNT },
  { label: 'CONTACT', value: ROLE_MODULE.CONTACT },
  { label: 'CHANNEL', value: ROLE_MODULE.CHANNEL },
  { label: 'CALENDAR', value: ROLE_MODULE.CALENDAR },
  { label: 'SALES', value: ROLE_MODULE.SALES },
  { label: 'ANALYTICS', value: ROLE_MODULE.ANALYTICS },
  { label: 'PEOPLE', value: ROLE_MODULE.ROLE },
  { label: 'BILLING', value: ROLE_MODULE.PLAN },
  { label: 'WEBHOOK', value: ROLE_MODULE.WEBHOOK },
  { label: 'AUTOMATION', value: ROLE_MODULE.AUTOMATION },
  { label: 'TAG', value: ROLE_MODULE.TAG },
  { label: 'VIEW', value: ROLE_MODULE.VIEW },
  { label: 'DATA', value: ROLE_MODULE.DATA },
  { label: 'CAMPAIGN', value: ROLE_MODULE.CAMPAIGN },
];

const DEFAULT_CALENDAR_SETTINGS = {
  availability: {
    monday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
    tuesday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
    wednesday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
    thursday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
    friday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
    saturday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
    sunday: {
      startTime: '0900',
      endTime: '1700',
      status: 'INACTIVE',
    },
  },
  eventBefore: 30,
  eventAfter: 30,
};

const WEEKDAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
] as const;

const ALL_DAYS = [...WEEKDAYS, 'SATURDAY', 'SUNDAY'] as const;

const DEFAULT_NOTIFICATION_SETTINGS = {
  type: 'ACCOUNT_USER',
  actions: {
    LEAD_ASSIGNED: { email: true, sms: true },
    BOOKING_APPOINTMENT: { email: true, sms: true },
    SMS: { email: true, sms: true },
  },
  summarySettings: {
    canReceiveSummary: true,
    times: '0900',
    days: [...WEEKDAYS],
  },
};

const NOTIFICATION_ACTIONS = [
  { key: 'LEAD_ASSIGNED', label: 'New Lead' },
  { key: 'SMS', label: 'New SMS' },
  { key: 'BOOKING_APPOINTMENT', label: 'New Booking' },
] as const;

const NOTIFICATION_TYPES = [
  { value: 'ACCOUNT_USER', label: 'Only items assigned to me' },
  { value: 'ALL', label: 'All team activity' },
] as const;

const NOTIFICATION_TIME_OPTIONS = Array.from({ length: 24 }, (_, hour) => {
  const hh = String(hour).padStart(2, '0');
  const period = hour < 12 ? 'AM' : 'PM';
  const display = hour % 12 === 0 ? 12 : hour % 12;
  return { value: `${hh}00`, label: `${display}:00 ${period}` };
});

export default {
  ...KEYS,
  DEFAULT_CALENDAR_SETTINGS,
  DEFAULT_NOTIFICATION_SETTINGS,
  NOTIFICATION_ACTIONS,
  NOTIFICATION_TYPES,
  NOTIFICATION_TIME_OPTIONS,
  WEEKDAYS,
  ALL_DAYS,
  ROLE_MODULES,
};
